import * as R from 'ramda';

import { getItemsArray } from 'redux/hor/module/selectors';

export const getItems = (userKey, state) => R.compose(
  R.filter(R.propEq('___owner', userKey)),
  getItemsArray,
)(state);
